import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installGlobalErrorTracking, trackAppOpen } from './lib/analytics';
import { enforceBlindHost } from './features/blindLink/OcultoHostGuard';
import { esErrorDeChunk, recargarUnaVez } from './lib/recargaPorDeploy';
import { instalarDemoRedes } from './dev/redesDemo';

// Primero de todo: en el dominio del link ciego, cualquier ruta que no sea una ficha
// se va a Booster antes de montar nada (si no, se veía la home de Imperium y el
// cliente descubría de qué inmobiliaria era la propiedad).
enforceBlindHost();

// eventos.inmobiliariaimperium.com: la raíz es el listado de eventos públicos (EVENTOS_PLAN.md,
// fase 2). Vercel ya redirige; esto cubre la navegación del lado del cliente y el local.
if (/^eventos\./i.test(window.location.hostname) && window.location.pathname === '/') {
  window.history.replaceState(null, '', '/eventos-publicos');
}

// Solo en desarrollo, con ?demo=1: Redes sociales con datos inventados (capturas).
instalarDemoRedes();

installGlobalErrorTracking();

// Modo de apertura (app instalada vs navegador), una vez por sesión. Es la única
// forma de saber quién tiene el CRM en la pantalla de inicio: la suscripción de
// notificaciones no sirve como prueba en Android, donde Chrome permite push sin instalar.
trackAppOpen();

// Tras un deploy los chunks viejos dejan de existir y los imports dinámicos fallan.
// Vite avisa por 'vite:preloadError' cuando el que falla es un PRELOAD suyo; el import
// del `lazy` va por otro camino y lo cubre `lazyConRecarga` en las rutas. Las dos capas
// comparten el guard de `recargarUnaVez`, así que entre ambas hay una sola recarga.
window.addEventListener('vite:preloadError', () => { recargarUnaVez(); });

// Última red: una promesa rechazada por un chunk que no está y que nadie atrapó (un
// import dinámico suelto, fuera de una ruta). Sin esto queda la pantalla a medias.
window.addEventListener('unhandledrejection', (e) => {
  if (esErrorDeChunk(e.reason)) { e.preventDefault(); recargarUnaVez(); }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
